import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { TdspBaseEntityService } from "../rest-common.service";
import { NotificationService } from "src/app/notification.service";
import { map } from "rxjs";
import { firstValueFrom } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class TdspCustomLocationService extends TdspBaseEntityService {
  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  get resource_url(): string {
    return `${this.activeBaseUrl}/custom-location/`;
  }

  private apiLoaded = false;
  public client_country: string;

  getKeyAndClientCountry(params = {}): Promise<string> {
    let url = this.buildUrl(`${this.resource_url}meta/`, "", params);

    return firstValueFrom(this.get(url)).then((res: any) => {
      const { google_maps_api_key, client_country } = res;

      return new Promise<string>((resolve, reject) => {
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${google_maps_api_key}&libraries=places`;
        script.async = true;
        script.defer = true;

        script.onload = () => {
          this.apiLoaded = true;
          this.client_country = client_country;
          resolve(client_country);
        };

        script.onerror = (err) => reject(err);

        document.head.appendChild(script);
      });
    });
  }
}
